import { Navigate, useRoutes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import SignUpForm from './DevelopmentComp/Others/SignUpForm';
import LoginPage from './DevelopmentComp/Others/LoginPage';
import DefectCategory from './DevelopmentComp/Masters/DefectCategory';
import User from './DevelopmentComp/Masters/User';
import DefectSubCategory from './DevelopmentComp/Masters/DefectSubCategory';
import AuditType from './DevelopmentComp/Masters/AuditType';
import AuditMapping from './DevelopmentComp/Masters/AuditMapping';
import FactoryProcessUnit from './DevelopmentComp/Masters/FactoryProcessUnit';
import AQLParameter from './DevelopmentComp/Masters/AQLParameter';
import UserPrivileges from './DevelopmentComp/Masters/UserPrivileges';
import AssignInspection from './DevelopmentComp/Transactions/AssignInspection';
import FactoryOrderSheet from './DevelopmentComp/Reports/FactoryOrderSheet';
import InspectionReport from './DevelopmentComp/Reports/InspectionReport';
import DefectSummary from './DevelopmentComp/Reports/DefectSummary';
import Inspections from './DevelopmentComp/Transactions/Inspections';
import InspectionTracker from './DevelopmentComp/Transactions/InspectionTracker';
import ViewInspection from './DevelopmentComp/Transactions/ViewInspection';
import FabricDefect from './DevelopmentComp/Masters/FabricDefect';
import FabricDefectPoints from './DevelopmentComp/Masters/FabricDefectPoints';
import FabricRollParameter from './DevelopmentComp/Masters/FabricRollParameter';
import FactoryLocation from './DevelopmentComp/Masters/FactoryLocation';
import FabricViewInspection from './DevelopmentComp/Transactions/FabricViewInspection';
import FabricInspectionTracker from './DevelopmentComp/Transactions/FabricInspectionTracker';
import FabricInspection from './DevelopmentComp/Transactions/FabricInspection';

// ----------------------------------------------------------------------

const isAuthenticated = () => {
  const token = sessionStorage.getItem('authToken');
  return token;
};

const hasAccess = (screenName) => {
  const access = !!sessionStorage.getItem(`${screenName}`);
  return access;
};

// ProtectedRoute HOC
const ProtectedRoute = ({ element, screenName }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAccess(screenName)) {
    return <Page404 />;
  }
  return element;
};

const ProtectedForViewInspectionRoute = ({ element, screenNames }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!screenNames?.map(screenName => hasAccess(screenName)).includes(true)) {
    return <Page404 />;
  }
  return element;
};

// for  techvel dashboard
export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <>
          <Helmet>
            <title>Inspection On Go | Dashboard</title>
          </Helmet>
          <DashboardLayout />
        </>
      ),

      children: [
        // Example Route
        { path: 'home', element: <DashboardAppPage />, shortname: 'Dashboard' },
        // Masters Route
        { path: 'masters/User', element: <User />, shortname: 'User_Master' },
        { path: 'masters/DefectCategory', element: <DefectCategory />, shortname: 'DefectCategory_Master' },
        { path: 'masters/DefectSubCategory', element: <DefectSubCategory />, shortname: 'DefectSubCategory_Master' },
        { path: 'masters/AuditType', element: <AuditType />, shortname: 'AuditType_Master' },
        { path: 'masters/AuditMapping', element: <AuditMapping />, shortname: 'AuditMapping_Master' },
        { path: 'masters/FactoryProcessUnit', element: <FactoryProcessUnit />, shortname: 'FactoryProcessUnit_Master' },
        { path: 'masters/AQLParameter', element: <AQLParameter />, shortname: 'AQLParameter_Master' },
        { path: 'masters/FabricDefect', element: <FabricDefect />, shortname: 'FabricDefect_Master' },
        { path: 'masters/FabricDefectPoints', element: <FabricDefectPoints />, shortname: 'FabricDefectPoints_Master' },
        { path: 'masters/FabricRollParameter', element: <FabricRollParameter />, shortname: 'FabricRollParameter_Master' },
        { path: 'masters/UserPrivileges', element: <UserPrivileges />, shortname: 'UserPrivileges_Master' },
        { path: 'masters/FactoryLocation', element: <FactoryLocation />, shortname: 'FactoryLocation_Master' },
        {
          path: 'transactions/AssignInspection',
          element: <AssignInspection />,
          shortname: 'AssignInspection_Transaction',
        },
        { path: 'transactions/Inspections', element: <Inspections />, shortname: 'Inspections_Transaction' },
         { path: 'transactions/FabricInspections', element: <FabricInspection />, shortname: 'FabricInspection_Transaction' },
        {
          path: 'transactions/InspectionTracker',
          element: <InspectionTracker />,
          shortname: 'InspectionTracker_Transaction',
        },
         { path: 'transactions/FabricInspectionTracker', element: <FabricInspectionTracker />, shortname: 'FabricInspectionTracker_Transaction' },

        { path: 'Reports/FactoryOrderSheet', element: <FactoryOrderSheet />, shortname: 'FactoryOrderSheet_Report' },
        { path: 'Reports/InspectionReport', element: <InspectionReport />, shortname: 'InspectionReport_Report' },
        { path: 'Reports/DefectSummary', element: <DefectSummary />, shortname: 'DefectSummary_Report' },
      ]
        .map((route) => ({
          ...route,
          element: <ProtectedRoute element={route.element} screenName={route.shortname} />,
        }))
        .concat([
          { path: '404', element: <Page404 /> },
          { path: '404', element: <UserPrivileges /> },
        ]),
    },
    {
      element: <ProtectedForViewInspectionRoute element={<ViewInspection />} screenNames={['Inspections_Transaction', 'DefectSummary_Report']} />,
      path: 'transactions/Inspections/preview/:QAInspectionId',
    },
    {
      element: <ProtectedForViewInspectionRoute element={<FabricViewInspection />} screenNames={['Inspections_Transaction', 'DefectSummary_Report']} />,
      path: 'transactions/fabricInspection/preview/:FabricInspectionId',
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'login',
      element: (
        <>
          <Helmet>
            <title>Inspection On Go | Login</title>
          </Helmet>
          <LoginPage />
        </>
      ),
    },
    {
      path: 'signup',
      element: (
        <>
          <Helmet>
            <title>Inspection On Go | Sign Up</title>
          </Helmet>
          <SignUpForm />
        </>
      ),
    },
  ]);

  return routes;
}
